<template>
  <div>
    <md-dialog :md-active.sync="showDialog">
      <md-dialog-title>Opciones del producto</md-dialog-title>

      <md-tabs md-dynamic-height>
        <md-tab
          v-for="(og, index) in options"
          :key="index"
          :md-label="og.name"
          class="scroll-modal"
        >
          <div v-for="(option, index) in og.options" :key="index">
            <AdditionalItemBandAid
              v-if="option.maxQty > 1"
              :option="option"
              :quantitySelected="getQuantitySelected(option)"
              @innerPlusQuantity="onInnerPlusQuantity(option)"
              @innerLessQuantity="onInnerLessQuantity(option)"
            />
            <AdditionalItemTick
              v-else
              :option="option"
              @checkOption="onCheckOption(option)"
            />
          </div>
        </md-tab>
      </md-tabs>

      <md-dialog-actions>
        <md-button class="md-primary" @click="dismiss">Cancelar</md-button>
        <md-button class="md-primary" @click="addProduct">Agregar</md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
import AdditionalItemBandAid from "./AdditionalItemBandAid";
import AdditionalItemTick from "./AdditionalItemTick";

export default {
  name: "AdditionalsDialog",
  data: () => ({}),
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Array,
    },
    selectedOptions: {
      type: Array,
    },
  },
  methods: {
    dismiss() {
      this.$emit("dismiss");
    },
    addProduct() {
      this.$emit("addProduct");
    },
    getQuantitySelected(op) {
      var so = this.selectedOptions.filter((t) => t.name === op.name);
      if (so !== undefined && so !== null && so.length > 0) {
        return so[0].quantity;
      } else {
        return 0;
      }
    },
    onInnerPlusQuantity(op) {
      var so = this.selectedOptions.filter((t) => t.name === op.name);
      if (so !== undefined && so !== null && so.length > 0) {
        let index = this.selectedOptions.indexOf(so[0]);
        this.selectedOptions.splice(index, 1);

        so[0].quantity++;

        this.selectedOptions.push(so[0]);
      } else {
        if (op.price === undefined) {
          op.price = "0.00";
        }
        this.selectedOptions.push({
          name: op.name,
          quantity: 1,
          price: op.price,
        });
      }
    },
    onInnerLessQuantity(op) {
      var so = this.selectedOptions.filter((t) => t.name === op.name);
      if (so !== undefined && so !== null && so.length > 0) {
        let index = this.selectedOptions.indexOf(so[0]);
        this.selectedOptions.splice(index, 1);

        if (so[0].quantity > 1) {
          so[0].quantity--;
          this.selectedOptions.push(so[0]);
        }
      }
    },
    onCheckOption(op) {
      var so = this.selectedOptions.filter((t) => t.name === op.name);
      if (so !== undefined && so !== null && so.length > 0) {
        let index = this.selectedOptions.indexOf(so[0]);
        this.selectedOptions.splice(index, 1);
      } else {
        if (op.price === undefined) {
          op.price = "0.00";
        }
        this.selectedOptions.push({
          name: op.name,
          quantity: 1,
          price: op.price,
        });
      }
    },
  },
  components: {
    AdditionalItemBandAid,
    AdditionalItemTick,
  },
};
</script>

<style lang="scss" scoped>
.md-dialog /deep/.md-dialog-container {
  max-width: 90vw;
  max-height: 140vw;
}
.scroll-modal {
  overflow: scroll;
  height: 400px;
}
</style>
<style>
.md-button {
  min-width: fit-content !important;
}
.md-dialog-container .md-tabs-navigation {
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/Components/AdditionalsDialog.vue